export const closeAppAllModal = (modal) => {
    modal.showModalUser = false;
    modal.showModalVersion = false;
    modal.showModalLang = false;
    modal.showModalConditions = false;
};

export default {
    closeAppAllModal
};